import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get targets() {
    return ["input", "form"];
  }

  connect() {
    this.observeMutations();
  }

  observeMutations() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const tooltipElements = $(node).find("[data-toggle='tooltip']");
              tooltipElements.each(function() {
                $(this).tooltip();
              });
              this.triggerActions(node);              
            }
          });
        }

        if (mutation.removedNodes.length > 0) {
          mutation.removedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              this.triggerActions(node);
            }
          });
        }
        setTimeout(() => {
          this.revalidateGrandTotal();
        }, 100);       
      });
    });

    observer.observe(this.element, {
      childList: true,
      subtree: true
    });
  }

  triggerActions(node) {
    const events = ["blur"];
    const actions = [
      "apply-jobs#milestonesTotal",
      "apply-jobs#updateMilestoneTotal",      
      "apply-jobs#checkSupplierPayment",
      "item-calculator#recalculate",
      "apply-jobs#displayPayment",
    ];

    events.forEach((event) => {
      actions.forEach((action) => {
        const customEvent = new CustomEvent(event, { bubbles: true, cancelable: true });
        const elements = document.querySelectorAll(`[data-action*="${action}"]`);
        elements.forEach((element) => {
          element.dispatchEvent(customEvent);
        });
      });
    });
  }
  
  revalidateGrandTotal() {
    const customEvent = new CustomEvent("change", { bubbles: true, cancelable: true });
    const elements = document.querySelectorAll("[data-action*='total-calculator#recalculate']");
    elements.forEach((element) => {
      element.dispatchEvent(customEvent);
    });
  }      
}